$(document).ready(function () {
  $(".size-guide-link").click(function (event) {
    event.preventDefault();
    $("#size-guide-popup").fadeIn();
    $("body").addClass("lock-scroll");
    $("#popup-overlay").fadeIn();
  });


  
  $("#close-popup").click(function () {
    $("#size-guide-popup").fadeOut();
    $("#popup-overlay").fadeOut();
    $("body").removeClass("lock-scroll");
  });


  
  $(document).mouseup(function (e) {
    var popupContent = $("#size-guide-content");
    if (!popupContent.is(e.target) && popupContent.has(e.target).length === 0) {
      $("#size-guide-popup").fadeOut();
      $("#popup-overlay").fadeOut();
      $("body").removeClass("lock-scroll");
    }
  });
});


// DOM Renderer handling
document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.matchMedia('(max-width: 999px)').matches;

  const mobileSidebars = document.querySelectorAll('.mobile-renderer');
  const desktopLocalizations = document.querySelectorAll('.desktop-renderer');

  if (isMobile) {
    desktopLocalizations.forEach(element => element.remove());
  } else {
    mobileSidebars.forEach(element => element.remove());
  }
});

$(document).ready(function () {
  $(".upsell_accordian").click(function () {
    if ($(".addon-product-card").is(":visible")) {
      $(".addon-product-card").slideUp();
      $(".upsell_accordian").addClass("rotate");
    } else {
      $(".addon-product-card").slideDown();
      $(".upsell_accordian").removeClass("rotate");
    }
  });
});


// ***** COLLECTION DESCRIPTION READMORE OR READLESS BUTTON START *****
(function () {
  var DESKTOP_WORD_LIMIT = 100;
  var MOBILE_WORD_LIMIT = 100;

  function getWordLimit() {
    return window.innerWidth <= 767
      ? MOBILE_WORD_LIMIT
      : DESKTOP_WORD_LIMIT;
  }

  function truncateByWords(element, wordLimit) {
    var walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null
    );

    var nodes = [];
    var node;

    while (node = walker.nextNode()) {
      nodes.push(node);
    }

    var wordCount = 0;
    var cutNode = null;
    var cutPosition = 0;

    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].nodeValue;
      var words = [...text.matchAll(/\S+/g)];

      if (!words.length) continue;

      if (wordCount + words.length <= wordLimit) {
        wordCount += words.length;
      } else {
        var remainingWords = wordLimit - wordCount;

        cutNode = nodes[i];

        if (remainingWords <= 0) {
          cutPosition = 0;
        } else {
          cutPosition =
            words[remainingWords - 1].index +
            words[remainingWords - 1][0].length;
        }

        break;
      }
    }

    if (!cutNode) {
      return false;
    }

    var range = document.createRange();

    range.setStart(cutNode, cutPosition);
    range.setEnd(element, element.childNodes.length);
    range.deleteContents();

    cutNode.parentNode.appendChild(
      document.createTextNode('…')
    );

    return true;
  }

  function initCollectionDescription() {
    var descriptions = document.querySelectorAll(
      '[data-collection-description]'
    );

    descriptions.forEach(function (wrapper) {
      var content = wrapper.querySelector(
        '[data-description-content]'
      );

      var button = wrapper.querySelector(
        '[data-description-toggle]'
      );

      if (!content || !button) return;

      var originalHTML = content.innerHTML;

      var plainText = content.textContent.trim();

      var totalWords = plainText
        ? plainText.match(/\S+/g).length
        : 0;

      var wordLimit = getWordLimit();

      if (totalWords <= wordLimit) {
        button.hidden = true;
        content.classList.add('is-expanded');
        return;
      }

      /*
       * Create shortened version
       */
      content.innerHTML = originalHTML;

      truncateByWords(
        content,
        wordLimit
      );

      /*
       * Save shortened HTML
       */
      var truncatedHTML = content.innerHTML;

      /*
       * Show Read More
       */
      button.hidden = false;
      button.textContent = 'Read More';
      button.setAttribute(
        'aria-expanded',
        'false'
      );

      content.classList.remove(
        'is-expanded'
      );

      /*
       * Prevent duplicate event
       */
      if (button.dataset.initialized === 'true') {
        return;
      }

      button.dataset.initialized = 'true';

      button.addEventListener(
        'click',
        function () {
          var expanded =
            content.classList.contains(
              'is-expanded'
            );

          if (expanded) {
            /*
             * READ LESS
             */
            content.innerHTML = truncatedHTML;

            content.classList.remove(
              'is-expanded'
            );

            button.textContent = 'Read More';

            button.setAttribute(
              'aria-expanded',
              'false'
            );
          } else {
            /*
             * READ MORE
             */
            content.innerHTML = originalHTML;

            content.classList.add(
              'is-expanded'
            );

            button.textContent = 'Read Less';

            button.setAttribute(
              'aria-expanded',
              'true'
            );
          }
        }
      );
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    initCollectionDescription
  );

  document.addEventListener(
    'shopify:section:load',
    initCollectionDescription
  );
})();

// **** COLLECTION DESCRIPTION READMORE OR READLESS BUTTON END *****



$(document).ready(function () {
  $("#custom_size").click(function () {
    $(
      ".invoice_message, .gpo-container"
    ).slideToggle();
    $(this).toggleClass("colored");
  });
});



$(document).ready(function () {
  $(".buy-buttons button.button").click(
    function () {
      setTimeout(function () {
        $(".added_cart_drawer").removeClass("hidden");
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("body").addClass("scroll-lock");
      }, 2000);
    }
  );
});



$(document).on("click", ".close_btn", function () {
  $(".added_cart_drawer").addClass("hidden");
  $(".added_cart_drawer_v3").addClass("hidden");
  $("body").removeClass("scroll-lock");
});



$(document).ready(function () {
  $("a.relative.open__cart").click(function () {
    $(".added_cart_drawer_v3").removeClass("hidden");
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
});




$(document).ready(function () {
  var productCount = $(".product-list a").length;

  $(".total_products").text(productCount);
});


// Review tab JS 
$(document).ready(function () {
    let reviewsShown = 20; 
    let currentFilter = 'all'; 

    $('.review-tab-btn').click(function () {
        $('.review-tab-btn').removeClass('active');
        $(this).addClass('active');
        currentFilter = $(this).data('tab'); 
        reviewsShown = 20; 
                filterReviews();
    });

    $('#load-more-reviews').click(function () {
        reviewsShown += 20; 
        showReviews();
    });

    function showReviews() {
        $('.custom-review-row').hide();
        let visibleReviews = getFilteredReviews();
        visibleReviews.slice(0, reviewsShown).show();
        if (visibleReviews.length > reviewsShown) {
            $('#load-more-reviews').show();
        } else {
            $('#load-more-reviews').hide();
        }
    }

    function filterReviews() {
        $('.custom-review-row').hide();
        let filteredReviews = getFilteredReviews();
        reviewsShown = 20;
        filteredReviews.slice(0, reviewsShown).show();
        if (filteredReviews.length > reviewsShown) {
            $('#load-more-reviews').show();
        } else {
            $('#load-more-reviews').hide();
        }
    }

    function getFilteredReviews() {
        if (currentFilter === 'all') {
            return $('.custom-review-row');
        } else {
            return $(`.custom-review-row[data-category*="${currentFilter}"]`);
        }
    }

    filterReviews();
});


$(document).ready(function () {
  // Function to toggle the Add to Cart button state
  function toggleAddToCart() {
    if ($(".variant-picker__option-values input:checked").length === 0) {
      $(".buy-buttons button.button").css("pointer-events", "none");
      // $(".inv-banner").css("display", "none");
    } else {
      $(".buy-buttons button.button").css("pointer-events", "unset");
      // $(".inv-banner").css("display", "flex");
    }
  }

  // Call the function initially to set the correct state
  toggleAddToCart();

  // Attach the change event to inputs
  $(".variant-picker__option-values input").on("change", function () {
    toggleAddToCart();
  });
  
  // Event handler when the Add to Cart button is clicked
  $('.buy-buttons, .shopify-payment-button').on('click', function () {
    if ($(".variant-picker__option-values input:checked").length === 0) {
      $('.size-error').html('Please select a size').show();
    }
  });
  

  // Reset logic when variant options are clicked
  $('.variant-picker__option-values input').on('click', function () {
    $('.size-error').hide();
    $(".invoice_message, .gpo-container").slideUp();

    // Reset PO number fields if a variant is selected
    if ($('.variant-picker__option-values input:checked').length > 0) {
      $('input#number-1').val('');
      $('input#number-2').val('');
      $('input#number-3').val('');
      $('input#number-4').val('');
      $('input#number-5').val('');
      $('input#number-6').val('');
      $('input#number-7').val('');
      $('input#number-8').val('');
    }
  });

  // Monitor the specific element visibility and handle form validation
  setInterval(function () {
    if ($('.gpo-container').css('display') === 'block') {
      // Reset the checked property for variant inputs
      $('.variant-picker__option-values input:checked').prop('checked', false);

      // Disable the button and show the default error
      $('.buy-buttons button.button').css("pointer-events", "none");
      $('.size-error').html('Please choose a size').show();

      // Fetch the values of PO number fields
      const NotSure = $('input#checkbox-1_1').prop('checked');
      const Chest = $('input#number-1').val() ? $('input#number-1').val().trim() : '';
      const Height = $('input#number-2').val() ? $('input#number-2').val().trim() : '';
      const NaturalWaist = $('input#number-3').val() ? $('input#number-3').val().trim() : '';
      const Weight = $('input#number-4').val() ? $('input#number-4').val().trim() : '';
      const LowerWaist = $('input#number-5').val() ? $('input#number-5').val().trim() : '';


      
      // Enable the button and hide the error if both PO fields are filled
      if ((Chest && Height && NaturalWaist && Weight && LowerWaist) || NotSure) {
        $('.size-error').hide();
        $('.buy-buttons button.button').css("pointer-events", "unset");
      } else {

         if ($('.gpo-container').css('display') === 'none') {
            $('.size-error').html('Please choose a size').show();
         }else{
            $('.size-error').html('Please provide all measurements').show();
         }
        
        $('.buy-buttons button.button').css("pointer-events", "none");
      }
    }else{
       $('.size-error').html('Please select a size');
    }


    // cart Drawer v3 made to measure jquery
    // Function to check and toggle visibility
    
     if ($('.secondary_information ul li').length > 0) {
          $('.calc.mtm').show(); // Show if <li> exists
      } else {
          $('.calc.mtm').hide(); // Hide if no <li> exists
      }



    
  }, 100); // Check every 100 milliseconds
});




// on scroll add to cart sticky for mobile in product page 
$(document).ready(function() {
    // Check if window width is <= 999
    if ($(window).width() <= 999) {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            
            if (scroll <= 500) {
                $('.product-sticky-bar').css('display', 'block');
            } 
            else if (scroll > 500 && scroll < 1200) {
                $('.product-sticky-bar').css('display', 'none');
            }
            else if (scroll >= 1200) {
                $('.product-sticky-bar').css('display', 'block');
            }
        });
    }
});






// Disabled right click (Ristriction)
(function(){
  // delay to allow lazy-loaded images to appear; adjust if needed
  const INIT_DELAY = 300;

  function protectAll() {
    const media = Array.from(document.querySelectorAll('img, video'));

    media.forEach(el => {
      try {
        // don't break if element is inside an editable admin area
        el.setAttribute('draggable', 'false');

        // Prevent right-click/context menu on the media element
        el.addEventListener('contextmenu', function(e){
          // allow if Ctrl/Meta key is pressed (advanced users) - optional
          // if (e.ctrlKey || e.metaKey) return;
          e.preventDefault();
        });

        // Prevent dragstart (desktop)
        el.addEventListener('dragstart', function(e){
          e.preventDefault();
        });

        // For touch devices: block long-press context menu by preventing contextmenu too
        // Some browsers fire 'contextmenu' after long-press; above listener covers it.
        // Add a small safeguard: intercept touchstart+touchend to detect long press and prevent default
        let touchStartTime = 0;
        el.addEventListener('touchstart', function(e){
          touchStartTime = Date.now();
        }, {passive: true});

        el.addEventListener('touchend', function(e){
          const delta = Date.now() - touchStartTime;
          // if long press (>=600ms) then stop propagation of next contextmenu event
          if (delta >= 600) {
            // Some Android browsers open native menu on long press; attempt to block
            e.preventDefault();
            e.stopPropagation();
          }
        }, {passive: false});

        // Prevent saving image via "long press then open in new tab" on some browsers
        // by catching touchcancel too
        el.addEventListener('touchcancel', function(e){
          e.preventDefault();
        }, {passive: false});

        // Small accessibility: allow keyboard focus + controls; do not remove pointer events
        el.style.webkitUserSelect = 'none';
        el.style.userSelect = 'none';
      } catch (err) {
        // ignore individual element errors
        console.warn('protect-media error', err);
      }
    });
  }

  // run initially and also after some time for lazy-loaded images
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(protectAll, INIT_DELAY);
  });

  // Re-run when new nodes are added (for SPA/lazy loading). Uses MutationObserver.
  const observer = new MutationObserver(function(muts){
    // simple strategy: run protectAll when new images/videos added
    let added = false;
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.tagName === 'IMG' || n.tagName === 'VIDEO' || n.querySelector && (n.querySelector('img') || n.querySelector('video')))) {
            added = true;
            break;
          }
        }
      }
      if (added) break;
    }
    if (added) {
      // small debounce
      setTimeout(protectAll, 150);
    }
  });

  observer.observe(document.documentElement || document.body, {childList: true, subtree: true});
})();



(function(){
  const LONG_PRESS_MS = 600; // long press duration threshold (ms)
  let lastTouchStart = 0;
  let lastTouchTarget = null;

  // CSS helper for iOS to reduce native callout
  const styleId = 'no-touch-callout-style';
  if (!document.getElementById(styleId)) {
    const s = document.createElement('style');
    s.id = styleId;
    s.textContent = `
      img, video { -webkit-touch-callout: none !important; -webkit-user-select: none !important; user-select: none !important; }
    `;
    document.head.appendChild(s);
  }

  // record touchstart time only for images/videos
  document.addEventListener('touchstart', function(e){
    const t = e.target.closest && e.target.closest('img,video');
    if (t) {
      lastTouchStart = Date.now();
      lastTouchTarget = t;
    } else {
      lastTouchStart = 0;
      lastTouchTarget = null;
    }
  }, { passive: true });

  // on touchend detect long press and prevent default actions
  document.addEventListener('touchend', function(e){
    if (!lastTouchTarget) return;
    const delta = Date.now() - lastTouchStart;
    if (delta >= LONG_PRESS_MS) {
      // Prevent the default behaviour triggered by long-press on some browsers
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      // Additionally remove any selection / focus
      try { window.getSelection().removeAllRanges(); } catch(_) {}
    }
    // reset
    lastTouchStart = 0;
    lastTouchTarget = null;
  }, { passive: false }); // NON-passive so we can call preventDefault()

  // touchcancel cleanup
  document.addEventListener('touchcancel', function(){
    lastTouchStart = 0;
    lastTouchTarget = null;
  }, { passive: true });

  // block contextmenu when it originates from a long-touch on an img/video
  document.addEventListener('contextmenu', function(e){
    const t = e.target.closest && e.target.closest('img,video');
    if (!t) return;
    // If we detected a recent long touch on this target, block the menu
    const now = Date.now();
    const delta = lastTouchStart ? (now - lastTouchStart) : Infinity;
    if (delta >= LONG_PRESS_MS || !lastTouchStart) {
      // If lastTouchStart is zero we still block to be safe for some browsers
      e.preventDefault();
      e.stopPropagation();
    }
  }, { passive: false });

})();